export const MISSIONS_TRANSLATION_KEYS = {
  MISSIONS_EMPTY_GO_TO_CASINO: 'go_to_casino',
  MISSIONS_EMPTY_SUBTITLE: 'missions_empty_subtitle',
  MISSIONS_EMPTY_TITLE: 'missions_empty_title',
  MISSIONS_TAB_AVAILABLE: 'missions_available',
  MISSIONS_TAB_COMPLETED: 'missions_completed',
  MISSIONS_TAB_LOCKED: 'missions_locked',
  MISSIONS_TAB_OVERVIEW: 'missions_overview',
};

export default MISSIONS_TRANSLATION_KEYS;
